import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'
import { toast } from 'sonner'

export default function useEditVault(vaultId) {
  const queryClient = useQueryClient()

  const action = async ({ name, description, amount, transaction_date }) => {
    const response = await httpClient.put(`team/vault/${vaultId}`, {
      name,
      description,
      opening_balance: amount,
      balance_as_of: transaction_date,
    })

    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        showToast: true,
      }),
    onSuccess: (e) => {
      queryClient.invalidateQueries({
        queryKey: ['vaults'],
      })

      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })

      toast.success(e?.response?.data?.message ?? 'Changes saved successfully')
    },
  })

  return {
    editVault: mutation.mutateAsync,
  }
}
